import {
  Box,
  ChakraProvider,
  Grid,
  HStack,
  VStack,
  theme,
} from "@chakra-ui/react";
import {
  QUALITYGATE_URL,
  REGION,
  USER_POOL_CLIENT_ID,
  USER_POOL_ID,
  VAULT_GATEWAY_URL,
} from "./environment";
import { Amplify } from "aws-amplify";
import Card from "./components/Card";
import { ColorModeSwitcher } from "./components/ColorModeSwitcher";
import ErrorBoundary from "./components/ErrorBoundary";
import { I18nextProvider } from "react-i18next";
import React from "react";
import { UserLoginIndicator } from "./components/UserLoginIndicator";
import { defaultNS } from "./setup/i18n-namespace";
import i18n from "./setup/i18n";
import { v4 } from "uuid";
import "@aws-amplify/ui-react/styles.css";
import "./App.scss";

/**
 * The application.
 *
 * @class
 */
function App() 
{
  console.info(`Starting MuMiver.se Portal v${process.env.REACT_APP_VERSION}`);

  const darkMode
    = window.matchMedia
    && window.matchMedia("(prefers-color-scheme: dark)").matches;

  const body = document.getElementsByTagName("body")[0];

  if (body !== null && darkMode && !body.classList.contains("dark-mode")) 
  {
    body.classList.add("dark-mode");
  }

  const cardArray = [
    {
      imageUrl: "https://via.placeholder.com/400x200/0099ff",
      showBadge: true,
      badgeText: "IFC",
      rating: 5,
      reviewcount: 22,
      title: "Quality Gate",
      description:
        "Check IFC files for validity. Upload IFC models and set up validation sets which will be used to check if an IFC matches the requirements.\r\nLorem ipsum",
      credits: 2,
      price: "9,99",
      endpoint: QUALITYGATE_URL,
      type: "link",
    },
    {
      imageUrl: "https://via.placeholder.com/400x200/ffaf00",
      showBadge: true,
      badgeText: "IFC",
      rating: 4,
      reviewcount: 125,
      title: "Vault Gateway",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      credits: 4,
      price: "19,99",
      endpoint: VAULT_GATEWAY_URL,
      type: "link",
    },
    {
      imageUrl: "https://via.placeholder.com/400x200/ffcf00",
      showBadge: true,
      badgeText: "DWG",
      rating: 3,
      reviewcount: 5,
      title: "Prüfung nach DIN EN 1231",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      credits: 1,
      price: "4,99",
      type: "text",
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cards: any[] = [];

  cardArray.forEach((elem) => 
  {
    cards.push(
      <Card
        key={v4()}
        imageUrl={elem.imageUrl}
        showBadge={elem.showBadge}
        badgeText={elem.badgeText}
        rating={elem.rating}
        reviewcount={elem.reviewcount}
        title={elem.title}
        description={elem.description}
        credits={elem.credits}
        price={elem.price}
        endpoint={elem.endpoint}
        type={elem.type}
      ></Card>,
    );
  });

  const amplifyConfig = {
    Auth: {
      region: REGION,
      userPoolId: USER_POOL_ID,
      userPoolWebClientId: USER_POOL_CLIENT_ID,
    },
  };

  Amplify.configure(amplifyConfig);

  return (
    <I18nextProvider i18n={i18n} defaultNS={defaultNS}>
      <ErrorBoundary>
        <ChakraProvider theme={theme}>
          <Box textAlign="left" fontSize="xl">
            <Grid minH="100vh" p={3}>
              <Box display="flex" justifyContent="flex-end">
                <ColorModeSwitcher justifySelf="flex-end" />
                <UserLoginIndicator justifySelf="flex-end" />
              </Box>
              <VStack spacing={8}>
                <HStack spacing={8}>{cards}</HStack>
              </VStack>
            </Grid>
          </Box>
        </ChakraProvider>
      </ErrorBoundary>
    </I18nextProvider>
  );
}

export default App;